import { Component, Input, OnInit } from '@angular/core';
import { MaterialSelect2Service } from '../../../../modules/@material-input/component/material-select2.service';
import { Subscription } from 'rxjs';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NotificationService } from '../../../../services/notification.service';
import { DictionariesService } from '../../../../services/dictionaries.service';
import { HttpClient } from '../../../../services/http.service';
import { PriceRankPipe } from '../../../../pipes/prices.pipe';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-flat-advanced',
    templateUrl: './flat-advanced.component.html',
    styleUrls: ['./flat-advanced.component.scss'],
    standalone: false
})
export class FlatAdvancedComponent implements OnInit {

public data: any = null;
  public form: UntypedFormGroup;
  @Input() public flatId = null;
  public chain_list = [];
  public type_otd = [];
  public loading = true;
  private paramSubscribe: Subscription;
  private dataSubscribe: Subscription;

  constructor(public activeRoute: ActivatedRoute, public fb: UntypedFormBuilder, public http: HttpClient,
              public notify: NotificationService, public priceRank: PriceRankPipe,
              public select2Service: MaterialSelect2Service, private dict_helper: DictionariesService) {
  }

  ngOnInit() {
    this.form = this.fb.group({
      'flat_is_apartment': [false],
      'flat_is_duplex': [false],
      'flat_is_mansarda': [false],
      'flat_is_studio': [false],
      'flat_add_export': [false],
      'flat_subagent_br_conditions': [''],
      'flat_subagent_oform_price': [''],
      'flat_subagent_pay_conditions': [''],
      'flat_tip_otd_id': [null],
      'flat_description_finish': [''],
      'bool_br_conditions': [false],
      'bool_oform_price': [false],
      'bool_pay_conditions': [false],
      'bool_tip_otd_id': [false],
      'bool_description_finish': [false],
      'housing_subagent_br_conditions': [{value: '', disabled: true}],
      'housing_subagent_oform_price': [{value: '', disabled: true}],
      'housing_subagent_pay_conditions': [{value: '', disabled: true}],
      'housing_tip_otd_id': [{value: '', disabled: true}],
      'housing_description_finish': [{value: '', disabled: true}],
      // --
      'flat_combined_wcs_count': [''],
      'flat_separate_wcs_count': [''],
    });

    if (this.flatId) {
      this.getData();
    }
  }

  getData() {
    this.http.resolvers({
      'data': this.http.post('Flat.get', {'realty_id': +this.flatId, 'tab': 'advanced'}),
      'dict_chainlist': this.dict_helper.get('Housing.get_chain'),
      'dict_type_otd': this.dict_helper.get('Dict.get_realty_type_otd'),
    }).then((resolvers) => {
      this.data = resolvers['data'];
      this.chain_list = resolvers['dict_chainlist'];
      this.type_otd = resolvers['dict_type_otd'];
      this.pathForm();
      this.loading = false;
    });
  }

  pathForm() {
    this.form.patchValue({
      'flat_category': this.data['flat_category'],
      'flat_description_finish': (this.data['flat_description_finish']) ? this.data['flat_description_finish'] : '',
      'flat_dog_bron': this.data['flat_dog_bron'],
      'flat_etazh': this.data['flat_etazh'],
      'flat_is_apartment': this.data['flat_is_apartment'],
      'flat_is_duplex': this.data['flat_is_duplex'],
      'flat_is_mansarda': this.data['flat_is_mansarda'],
      'flat_is_studio': this.data['flat_is_studio'],
      'flat_add_export': this.data['flat_add_export'],
      'flat_koef_balkonov': this.data['flat_koef_balkonov'],
      'flat_koef_lodjiy': this.data['flat_koef_lodjiy'],
      'flat_kol_vo_balkonov': this.data['flat_kol_vo_balkonov'],
      'flat_kol_vo_lodjiy': this.data['flat_kol_vo_lodjiy'],
      'flat_kol_vo_urovney': this.data['flat_kol_vo_urovney'],
      'flat_num': this.data['flat_num'],
      'flat_num_pp': this.data['flat_num_pp'],
      'flat_plochad_bez_neotaplivaemich': this.data['flat_plochad_bez_neotaplivaemich'],
      'flat_plochad_obsh': this.data['flat_plochad_obsh'],
      'flat_plosch_balkonov': this.data['flat_plosch_balkonov'],
      'flat_plosch_lodjiy': this.data['flat_plosch_lodjiy'],
      'flat_ploshad_kuchni': this.data['flat_ploshad_kuchni'],
      'flat_ploshad_shil': this.data['flat_ploshad_shil'],
      'flat_pom_type': this.data['flat_pom_type'],
      'flat_price': this.data['flat_price'],
      'flat_price_promo': this.data['flat_price_promo'],
      'flat_rooms': this.data['flat_rooms'],
      'flat_section': this.data['flat_section'],
      'flat_stoimost_kv_metra': this.data['flat_stoimost_kv_metra'],
      'flat_stoimost_kv_metra_ddu': this.data['flat_stoimost_kv_metra_ddu'],
      'flat_subagent_agd': this.data['flat_subagent_agd'],
      'flat_subagent_br_conditions': (this.data['flat_subagent_br_conditions']) ?
        this.data['flat_subagent_br_conditions'] : '',
      'flat_subagent_oform_price': [(this.data['flat_subagent_oform_price']) ?
        this.data['flat_subagent_oform_price'] : ''],
      'flat_subagent_pay_conditions': (this.data['flat_subagent_pay_conditions']) ?
        this.data['flat_subagent_pay_conditions'] : '',
      'bool_br_conditions': this.data['bool_br_conditions'],
      'bool_oform_price': this.data['bool_oform_price'],
      'bool_pay_conditions': this.data['bool_pay_conditions'],
      'bool_tip_otd_id': this.data['bool_tip_otd_id'],
      'bool_description_finish': this.data['bool_description_finish'],
      'housing_subagent_br_conditions': this.data['housing_subagent_br_conditions'],
      'housing_subagent_oform_price': this.data['housing_subagent_oform_price'],
      'housing_subagent_pay_conditions': this.data['housing_subagent_pay_conditions'],
      'housing_tip_otd_id': (this.data['housing_tip_otd_id']) ? '' + this.data['housing_tip_otd_id'] : '',
      'housing_description_finish': this.data['housing_description_finish'],
      'flat_tip_otd_id': (this.data['flat_tip_otd_id']) ? '' + this.data['flat_tip_otd_id'] : '',
      // 'realty_parent_chain_caption': this.data['realty_parent_chain_caption'],
      'rooms': [],
      'flat_combined_wcs_count': this.data['flat_combined_wcs_count'] || '',
      'flat_separate_wcs_count': this.data['flat_separate_wcs_count'] || '',
    });
    this.select2Service.reload();
  }

  saveForm() {
    if (!this.form.valid) {
      this.onError('Заполните обязательные поля');
      return false;
    }
    let data = this.form.value;
    data['flat_subagent_br_conditions'] = (this.form.value.bool_br_conditions) ? null
      : this.form.value.flat_subagent_br_conditions;
    data['flat_subagent_oform_price'] = (this.form.value.bool_oform_price) ? null
      : +this.form.value.flat_subagent_oform_price;
    data['flat_subagent_pay_conditions'] = (this.form.value.bool_pay_conditions) ? null
      : this.form.value.flat_subagent_pay_conditions;
    data['flat_description_finish'] = (this.form.value.bool_description_finish) ? null
      : this.form.value.flat_description_finish;
    data['flat_tip_otd_id'] = (this.form.value.bool_tip_otd_id) ? null : this.form.value.flat_tip_otd_id;
    this.http.post('Flat.update_flat',
      {'realty_id': +this.flatId, 'data': {'advanced': data}}
    ).subscribe(
      (response) => this.onSuccess(response),
      (error) => this.onError(error)
    );
  }

  onSuccess(response) {
    this.notify.notifySuccess('Поздравляем', 'Данные успешно сохранены', 3000);
  }

  onError(error) {
    this.notify.notifyError('Ошибка', error, 5000);
  }

  ngOnDestroy() {
    if (this.paramSubscribe) {
      this.paramSubscribe.unsubscribe();
    }
    if (this.dataSubscribe) {
      this.dataSubscribe.unsubscribe();
    }
  }

}
